import { FC, useCallback, useMemo } from 'react';

import {
  Autocomplete,
  Option,
} from '@beeline/design-system-react/extracted-styles';

import { noop } from 'src/utils/noop';

import { labelsByBookingObjectType } from './consts';
import { BookingObjectType } from './types';

export interface BookingObjectTypeSelectProps {
  options: Option<string>[];
  bookingObjectType: BookingObjectType | undefined;
  setBookingObjectType: (bookingObjectType: BookingObjectType) => void;
  disabled?: boolean;
}

const renderValue = (option: Option<string> | null): string =>
  option?.value ?? '';

export const BookingObjectTypeSelect: FC<BookingObjectTypeSelectProps> = ({
  options,
  bookingObjectType,
  setBookingObjectType,
  disabled,
}) => {
  const values = useMemo((): Option<string> | null => {
    return bookingObjectType
      ? {
          id: bookingObjectType,
          value: labelsByBookingObjectType[bookingObjectType],
        }
      : null;
  }, [bookingObjectType]);

  const handleChange = useCallback(
    (nextValue: Option<string> | null) => {
      setBookingObjectType((nextValue?.id as BookingObjectType) ?? null);
    },
    [setBookingObjectType],
  );

  return (
    <Autocomplete<string>
      type='select'
      size='medium'
      label='Объект бронирования'
      fullWidth
      placeholder='выберите объект бронирования'
      noOptionsText='нет объектов бронирования'
      options={options}
      value={values}
      onChange={handleChange}
      multiple={false}
      disabled={disabled}
      dataTestId='bookingObjectType'
      onInputChange={noop}
      onInputClear={noop}
      renderValue={renderValue}
    />
  );
};
